<template>
    <section>
        Esta pinga no funciona
     
      </section>
</template>
<script>
export default{
    name:'Condiciones'
}
    
</script>


// WEBPACK FOOTER //
// src/Condiciones.vue